module.exports = __webpack_public_path__ + "img/blue-rect.1f2f90e0.png";